export default {
  API_ENDPOINT: 'https://afternoon-cove-86140.herokuapp.com/api',
  API_KEY: process.env.REACT_APP_API_KEY,
}
